import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-esr-submit',
    imports: [RouterModule],
    templateUrl: './closeRequest.component.html',
    styleUrl: './closeRequest.component.scss'
})
export class CloseRequestComponent implements OnInit {
  name: string | undefined = undefined;
  issueResolution: string | undefined = undefined;

  ngOnInit() {}

  updateName(evt: any) {
    this.name = evt.target.value;
  }

  updateRequestResolution(evt: any) {
    this.issueResolution = evt.target.value;
  }
}
